const initialState = {
  loading: false,
  activities: [],
  overdueActivities: [],
  upcomingActivities: [],
  editComment: { id: '', comment: '' },
  deleteCommentObj: { deleteCommentId: '', isDeleteComment: false },

  error: null,
  filters: { type: 'all', status: 'all', assignedTo: 'me', dateRange: 'today', priority: 'all', page: 1, limit: 20, sort: '-createdAt' },

  selectedActivity: null,
  pagination: { currentPage: 1, totalPages: 1, totalItems: 0, itemsPerPage: 20 },
  statistics: { total: 0, completed: 0, pending: 0, inProgress: 0, overdue: 0, completionRate: 0, typeBreakdown: {}, priorityBreakdown: {} },
  activityModal: { isOpen: false, type: 'task', data: null },
  activityForm: {
    // Common fields
    valueRichText: '',

    // Task fields
    taskTitle: '',
    taskType: 'to-do',
    priority: 'medium',
    assignee: {},
    dueDate: '',
    dueTime: '12:00',
    reminderType: 'email',
    reminderDate: '',
    isRecurring: false,
    queue: 'none',

    // Note fields
    followUpDate: '',
    createFollowUp: false,
    followUpTaskType: 'to-do',
    
    // Attachments
    attachments: [], // Array of attachment objects
    pendingAttachments: [] // Files waiting to be uploaded
  },
  dropdowns: {
    showMore: false,
    showAssociated: false,
    dropdownOpenTODO: false,
    dropdownOpenDays: false,
    dropdownOpenQueue: false,
    dropdownOpenClient: false,
    dropdownOpenDaysTask: false,
    dropdownOpenPriority: false,
  },

  associations: {}, // Dynamic associations: { deals: [], contacts: [], companies: [], ... }
  activeActivityBox: null, // null | 'note' | 'task' | 'schedule' | 'mail' | 'call' | 'sms'
  activitySource: null, // Source of activity creation: 'pipeline' | 'viewModal' | 'sidebar' | null
  selectedContactEmail: null, // Email of selected contact for emails
  objectData: null, // Object data (deal/contact/company) for activity context
  
  // Attachments
  attachments: {
    uploading: false,
    uploadProgress: {}, // { [fileId]: percentage }
    tempFiles: [], // Files being uploaded
    errors: {}, // Upload errors by fileId
    activityAttachments: {} // { [activityId]: attachments[] }
  },

  // Generic Communication State (SMS, Email, WhatsApp, Call)
  // Note: Connection status is now managed in Integration store via integrationStatus[toolName]
  communication: {
    sms: { messages: [], loading: false, sending: false },
    email: { messages: [], loading: false, sending: false },
    whatsapp: { messages: [], loading: false, sending: false },
    call: { agents: [], phones: [], loading: false, sending: false }
  }
};

const ActivitiesReducer = (state = initialState, action) => {
  switch (action['type']) {
    case 'CREATE_ACTIVITY':
      return { ...state, loading: true, error: null };

    case 'SET_ACTIVITY':
      return { ...state, activities: action['payload'], loading: false, error: null };

    case 'SET_SINGLE_ACTIVITY':
      return { ...state, selectedActivity: action['payload'], loading: false, error: null };

    case 'SET_ACTIVITY_LOADING':
      return { ...state, loading: action['payload'] };

    case 'SET_ACTIVITY_ERROR':
      return { ...state, error: action['payload'], loading: false };

    case 'TOGGLE_ACTIVITY_MODAL':
      return {
        ...state,
        activityModal: {
          isOpen: action['payload']['isOpen'] !== undefined ? action['payload']['isOpen'] : !state['activityModal']['isOpen'],
          type: action['payload']['type'] || state['activityModal']['type'],
          data: action['payload']['data'] !== undefined ? action['payload']['data'] : state['activityModal']['data']
        }
      };

    case 'SET_ACTIVITY_TYPE':
      return { ...state, activityModal: { ...state['activityModal'], type: action['payload'] } };

    case 'UPDATE_ACTIVITY_FORM_FIELD':
      return {
        ...state,
        activityForm: { ...state['activityForm'], [action['payload']['field']]: action['payload']['value'] }
      };

    case 'RESET_ACTIVITY_FORM':
      return {
        ...state,
        activeActivityBox: null,
        selectedContactEmail: null,
        objectData: null,
        dropdowns: initialState.dropdowns,
        activityForm: initialState.activityForm,
      };

    case 'TOGGLE_DROPDOWN':
      return {
        ...state,
        dropdowns: { ...state['dropdowns'], [action['payload']]: !state['dropdowns'][action['payload']] }
      };

    case 'SET_ACTIVE_ACTIVITY_BOX':
      // If sourceId is 'related', merge associations instead of replacing
      const newAssociations = action['payload']?.['sourceId'] === 'related'
        ? { ...state['associations'], ...action['payload']?.['associations'] }
        : action['payload']?.['associations'] || {};

      return {
        ...state,
        associations: newAssociations,
        activeActivityBox: action['payload']?.['activityBox'],
        activitySource: action['payload']?.['source'] || state['activitySource'],
        selectedContactEmail: action['payload']?.['selectedContactEmail'] || null,
        objectData: action['payload']?.['objectData'] || null
      };

    case 'SET_EDIT_COMMENT':
      return {
        ...state,
        editComment: { ...state['editComment'], id: action['payload']['id'], comment: action['payload']['comment'] }
      };

    case 'SET_DELETE_COMMENT':
      return {
        ...state,
        deleteCommentObj: { ...state['deleteCommentObj'], deleteCommentId: action['payload']['deleteCommentId'], isDeleteComment: action['payload']['isDeleteComment'] }
      };
      
    // Attachment cases
    case 'ADD_PENDING_ATTACHMENT':
      return {
        ...state,
        activityForm: { ...state['activityForm'], pendingAttachments: [...state['activityForm']['pendingAttachments'], action['payload']] }
      };

    case 'UPLOAD_ATTACHMENT':
      return {
        ...state,
        attachments: { ...state['attachments'], uploading: true, tempFiles: [...state['attachments']['tempFiles'], action['payload']['file']] }
      };

    case 'SET_UPLOAD_PROGRESS':
      return {
        ...state,
        attachments: { ...state['attachments'], uploadProgress: { ...state['attachments']['uploadProgress'], [action['payload']['fileId']]: action['payload']['progress'] } }
      };

    case 'UPLOAD_ATTACHMENT_SUCCESS':
      return {
        ...state,
        attachments: {
          ...state['attachments'],
          uploading: false,
          tempFiles: state['attachments']['tempFiles'].filter(f => f['id'] !== action['payload']['fileId']),
          uploadProgress: { ...state['attachments']['uploadProgress'], [action['payload']['fileId']]: undefined }
        },
        activityForm: {
          ...state['activityForm'],
          attachments: [...state['activityForm']['attachments'], action['payload']['attachment']],
          pendingAttachments: state['activityForm']['pendingAttachments'].filter(f => f['id'] !== action['payload']['fileId'])
        }
      };

    case 'UPLOAD_ATTACHMENT_FAILURE':
      return {
        ...state,
        attachments: {
          ...state['attachments'],
          uploading: false,
          errors: { ...state['attachments']['errors'], [action['payload']['fileId']]: action['payload']['error'] },
          tempFiles: state['attachments']['tempFiles'].filter(f => f['id'] !== action['payload']['fileId']),
          uploadProgress: { ...state['attachments']['uploadProgress'], [action['payload']['fileId']]: undefined }
        }
      };

    case 'REMOVE_ATTACHMENT':
      return {
        ...state,
        activityForm: { ...state['activityForm'], attachments: state['activityForm']['attachments'].filter(a => a['_id'] !== action['payload']) }
      };

    case 'SET_ACTIVITY_ATTACHMENTS':
      return {
        ...state,
        attachments: { ...state['attachments'], activityAttachments: { ...state['attachments']['activityAttachments'], [action['payload']['activityId']]: action['payload']['attachments'] } }
      };

    case 'CLEAR_PENDING_ATTACHMENTS':
      return {
        ...state,
        activityForm: { ...state['activityForm'], pendingAttachments: [] },
        pendingAttachments: []
      };

    case 'REMOVE_PENDING_ATTACHMENT':
      return {
        ...state,
        activityForm: {
          ...state['activityForm'],
          pendingAttachments: state['activityForm']['pendingAttachments'].filter(f => f['id'] !== action['payload'])
        }
      };

    // Generic Communication Cases (SMS, Email, WhatsApp)
    // Note: Connection status checking moved to Integration store - use getIntegrationStatus(toolName)

    case 'SET_COMMUNICATION_LOADING':
      return {
        ...state,
        communication: {
          ...state['communication'],
          [action['payload']['channel']]: { ...state['communication'][action['payload']['channel']], loading: action['payload']['loading'] }
        }
      };

    case 'SET_COMMUNICATION_SENDING':
      return {
        ...state,
        communication: {
          ...state['communication'],
          [action['payload']['channel']]: { ...state['communication'][action['payload']['channel']], sending: action['payload']['sending'] }
        }
      };

    case 'SET_COMMUNICATION_HISTORY':
      return {
        ...state,
        communication: {
          ...state['communication'],
          [action['payload']['channel']]: { ...state['communication'][action['payload']['channel']], messages: action['payload']['messages'], loading: false }
        }
      };

    case 'ADD_COMMUNICATION_MESSAGE':
      return {
        ...state,
        communication: {
          ...state['communication'],
          [action['payload']['channel']]: {
            ...state['communication'][action['payload']['channel']],
            messages: [...state['communication'][action['payload']['channel']]['messages'], action['payload']['message']],
            sending: false
          }
        }
      };

    case 'SET_COMMUNICATION_RESOURCES':
      return {
        ...state,
        communication: {
          ...state['communication'],
          [action['payload']['channel']]: {
            ...state['communication'][action['payload']['channel']],
            agents: action['payload']['agents'] || [],
            phones: action['payload']['phones'] || [],
            loading: false
          }
        }
      };

    default:
      return state;
  }
};

export default ActivitiesReducer;